

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {IOnOffHandlers} from "bonomo/dist";
  import {Prop} from "vue-property-decorator";

  @Component({
    name: 'CreateButton',
  })
  export default class CreateButton extends Vue {

    @Prop()
    protected title!: string;
    @Prop()
    protected label!: string;
    @Prop()
    protected disabled!: boolean;
    @Prop()
    protected to!: string;

    protected subscribes: IOnOffHandlers = {};
    protected disabledLocal: boolean = false;

    get isDisabled(): boolean {
      return this.disabled || this.disabledLocal;
    }

    created() {
      this.subscribes = this.$ons({
        'backend.call.begin': this.onDisable,
        'backend.call.OK': this.onOK,
        'backend.call.KO': this.onKO,
      });
    }
    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    protected onDisable() {
      this.disabledLocal = true;
    }
    protected onOK() {
      this.disabledLocal = false;
    }
    protected onKO() {
      this.disabledLocal = false;
    }

    protected onClick() {
      this.$emit('click');
    }

  }

